import { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import { Link } from "react-router";
import { useApiCall } from "../../../../../custom-hooks/api-call";
import DataNotFound from "../../../../../ui/loader/data-not-found";
import InnerLoader from "../../../../../ui/loader/inner-loader";
import Avatar from "../../../../../ui/avatar";
import { BookOpen, Calendar, FileDown, FileText, Home, LayoutDashboard, MessageSquare, Newspaper, Shield } from "lucide-react";
import useNav from "../../../../../../script/tabingNavArray";

const pagesLable = [
  {
    title: "My Space",
    items: [
      { label: "Overview", icon: <Home size={'1em'} />, url: '/my-space/overview' },
      { label: "Dashboard", icon: <LayoutDashboard size={'1em'} />, url: '/my-space/dashboard' },
      { label: "Calander", icon: <Calendar size={'1em'} />, url: '/my-space/calendar' },
    ],
  },
  {
    title: "Leave",
    items: [
      { label: "Leave Summary", icon: <FileDown size={'1em'} />, url: "/leave/my-data/overview" },
      { label: "Leave Balance", icon: <MessageSquare size={'1em'} />, url: "/leave/my-data/balance" },
      { label: "Leave Request", icon: <FileText size={'1em'} />, url: "/leave/my-data/request" },
    ],
  },
  {
    title: "Attendance",
    items: [
      { label: "Attendance Overview", icon: <BookOpen size={'1em'} />, url: '/attendance/my-data/overview' },
      { label: "Attendance Summary", icon: <Shield size={'1em'} />, url: '/attendance/my-data/summary' },
      { label: "Overtime", icon: <Newspaper size={'1em'} />, url: '/attendance/my-data/overtime' },
    ],
  },

];

const SearchPopup = ({ isOpen, onClose }) => {
  const useNavs = useNav();
  const apiCall = useApiCall();
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef();
  const [filtered, setFiltered] = useState([]);
  const [loader, setLoader] = useState(false);
  const [defaultState, setDefaultState] = useState(true);
  const [count, setCount] = useState(null);

  const callToApi = async (searchKey) => {
    setLoader(true);
    setCount(null)
    try {
      const apiData = JSON.stringify({ search_text: searchKey });
      const reps = await apiCall({ method: 'post', url: 'generic-search', data: apiData });
      setFiltered(reps?.search_text_result?.slice(0, searchKey ? reps?.search_text_result?.length : 10) || []);
      setCount(reps?.search_count);
    } catch (error) {
      console.error("API Error:", error);
      setFiltered([]);
      setCount(null);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const trimmed = searchTerm.trim();

      // If less than 3 characters → show default screen
      if (trimmed.length < 3) {
        setDefaultState(true);
        setFiltered([]);
        setCount(null);
        setLoader(false);
        return;
      }

      // If 3 or more characters → show search result
      setDefaultState(false);
      callToApi(trimmed);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setSearchTerm('');
        setDefaultState(true);
        onClose();
      };
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen]);

  const clos = () => {
    setSearchTerm('');
    setDefaultState(true);
    onClose();
  }

  if (!isOpen) return null;

  return (
    <div className={`${Style.search_backdrop}`} onClick={() => clos()}>
      <div className={`${Style.search_container}`} onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className={Style.searchInput}>
          <label htmlFor="searchInputRef" className={Style.searchIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="11" cy="11" r="7" strokeWidth="2" />
              <path d="M21 21l-4.3-4.3" strokeWidth="2" />
            </svg>
          </label>
          <input
            id="searchInputRef"
            type="text"
            ref={searchInputRef}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search people by name, email, phone?"
            className={Style.search_input}

            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            name="no-autofill"   // important for Chrome
          />

          <div className={Style.search_closed} onClick={() => { onClose() }}>esc</div>
        </div>

        <div className={Style.search_body}>
          {
            defaultState ? (
              <div className={Style.defaulState}>
                <div className={'grid grid-cols-2 gap-6'}>
                  {pagesLable?.map((sec) => (
                    <div key={`GG_${sec.title}`} className="col-span-1">
                      <h4 className="text-xs font-semibold tracking-wider text-gray-500 mb-3">
                        {sec.title.toUpperCase()}
                      </h4>
                      <div className="flex flex-wrap !gap-2">
                        {sec.items.map((item) => (
                          <Link
                            to={item?.url}
                            key={`XX_${item?.label}`}
                            className="flex items-center gap-3 w-full p-2 rounded-lg text-[#006bd6] border border-[#e8eaee80] bg-[#f6f7f866] hover:bg-[#ebf5ff] hover:border-[#66b2ff] transition"
                          >
                            <span className="text-blue-400 text-lg">{item?.icon}</span>
                            <span className="text-sm font-medium">{item?.label}</span>
                          </Link>
                        ))}
                      </div>
                    </div>
                  ))}
                  {/* <div className={Style.defaulState_item}>
                    <div className={Style.defaulState_card}>
                      <div className={Style.icon}>
                        <UserIcon />
                      </div>
                      Employee
                    </div>
                  </div> */}
                </div>
              </div>
            ) : (
              <div className={Style.userList}>
                <div className={Style.search_list}>
                  {!loader ? (
                    (filtered?.length > 0) ? (
                      filtered.map((item, idx) => (
                        <div key={idx} className={Style.search_item}>
                          <Avatar width={50} height={50} src={item.user_profile_picture} title={item?.user_name} />

                          <div className={Style.cont}>
                            <h6>
                              {item.user_name}
                              <div className={`${(item?.emp_status == 'Active') ? Style.active : Style.inActive} ${Style.status}`}>
                                <b></b>
                              </div>
                            </h6>
                            <h5>{item.user_designation}</h5>
                            <p><span>{item.user_department_name}</span></p>
                            <div className={Style.tags}>
                              {
                                (item?.tags).map((ele, idex) => {
                                  return (
                                    <div key={`${idx}-${idex}`} className={Style.tag}>{ele}</div>
                                  )
                                })
                              }
                              <a href={`mailto:${item?.user_email}`} className={Style.tagEmail}>{item?.user_email ? `@${(item?.user_email)?.split('@')[0]}` : "-"}</a>
                            </div>

                            <div className={Style.detailIcon}>
                              <a href={`mailto:${item?.user_email}`} className={Style.detailAction}>
                                <svg data-source-pos="389:22-389:69" data-source-name="IconMail" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-5 h-5 text-slate-500"><path data-source-pos="138:4-138:46" data-source-name="path" d="M4 6h16v12H4z" strokeWidth="2"></path><path data-source-pos="139:4-139:48" data-source-name="path" d="M22 6l-10 7L2 6" strokeWidth="2"></path></svg>
                              </a>

                              <Link target="_blank" to={`/organization/employee-directory/${item?.user_id}`} className={Style.detailAction}>
                                <svg data-source-pos="399:22-399:69" data-source-name="IconUser" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-5 h-5 text-slate-500"><path data-source-pos="144:4-144:66" data-source-name="path" d="M12 12a5 5 0 100-10 5 5 0 000 10z" strokeWidth="2"></path><path data-source-pos="145:4-145:53" data-source-name="path" d="M2 22a10 10 0 0120 0" strokeWidth="2"></path></svg>
                              </Link>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="w-full h-full flex items-center justify-center">
                        <DataNotFound title={"Result"} className={Style.noDataFound} />
                      </div>
                    )
                  ) : (
                    <InnerLoader />
                  )}
                </div>
              </div>
            )
          }
        </div>
        <div className={Style.search_footer}>
          {count !== null ? `Result: ${count}` : ""}
        </div>
      </div>
    </div>
  );
};

export default SearchPopup;
